import { render } from "./HTwbMind.vue?vue&type=template&id=2f8abe72"
import script from "./HTwbMind.vue?vue&type=script&lang=js"
export * from "./HTwbMind.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__